module.exports = __webpack_public_path__ + "static/media/bitbucket.8835d733.png";